import { put, call, takeEvery, all } from 'redux-saga/effects'
import isEmpty from 'lodash.isempty'
import { ACTION_TYPES } from 'store/reducers/addressInfo'
import { getAddressInfo, getPostalCodeInfo } from 'services'
import { ACTION_TYPES as NOTIFICATION_TYPES } from 'store/reducers/notification'
import { PAGE_ADDRESS_INFO } from 'config/messages'

const { LABEL_INVALID_CEP } = PAGE_ADDRESS_INFO
const {
  ADDRESS_INFO_REQUEST,
  GET_POSTALCODE_REQUEST,
  GET_POSTALCODE_SUCCESS,
  GET_POSTALCODE_ERROR,
  ADDRESS_INFO_SUCCESS,
  ADDRESS_INFO_ERROR
} = ACTION_TYPES

export function *addressInfo() {
  try {
    const response = yield call(getAddressInfo)
    yield put({ type: ADDRESS_INFO_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: ADDRESS_INFO_ERROR, payload: err })
  }
}

export function *getPostalCode({ payload }) {
  try {
    const response = yield call(getPostalCodeInfo, payload)
    if (isEmpty(response.data)) {
      yield put({
        type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
        payload: { text: LABEL_INVALID_CEP, type: 'error' }
      })
      return
    }
    yield put({ type: GET_POSTALCODE_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: GET_POSTALCODE_ERROR, payload: err })
  }
}

export default function *watchAddressInfo() {
  yield all([
    takeEvery(ADDRESS_INFO_REQUEST, addressInfo),
    takeEvery(GET_POSTALCODE_REQUEST, getPostalCode)
  ])
}
